// extracted by mini-css-extract-plugin
export default {"Caption":"Video-module--Caption--hF3bL"};